// extracted by mini-css-extract-plugin
var _1 = "AppStoreBadges__Badge___zQWKs";
var _2 = "AppStoreBadges__wiggle___W6yD7";
export { _1 as "Badge", _2 as "wiggle" }
